import {
  AlertCircle,
  CheckCircle,
  Clock,
  TrendingUp,
  XCircle,
} from "lucide-react";

/**
 * Renders a coloured pill badge for a given escalation status.
 * @param {string} status     — raw backend value e.g. "IN_PROGRESS"
 * @param {object} t          — text[language] translations object
 * @param {string} screenSize
 * @param {object} fonts
 */
const StatusBadge = ({ status, t, screenSize, fonts }) => {
  const baseStyle = {
    padding: screenSize === "xs" ? "0.25rem 0.5rem" : "0.25rem 0.625rem",
    borderRadius: "0.75rem",
    fontSize: fonts.small,
    fontWeight: "600",
    display: "inline-flex",
    alignItems: "center",
    gap: "0.25rem",
  };

  const statusConfig = {
    NOT_ASSIGNED: {
      bg: "#f3f4f6",
      color: "#374151",
      icon: <AlertCircle size={12} />,
      text: t.statusNotAssigned,
    },
    PENDING: {
      bg: "#fef3c7",
      color: "#92400e",
      icon: <Clock size={12} />,
      text: t.statusPending,
    },
    IN_PROGRESS: {
      bg: "#dbeafe",
      color: "#1e40af",
      icon: <TrendingUp size={12} />,
      text: t.statusInProgress,
    },
    RESOLVED: {
      bg: "#d1fae5",
      color: "#065f46",
      icon: <CheckCircle size={12} />,
      text: t.statusResolved,
    },
    REJECTED: {
      bg: "#fee2e2",
      color: "#991b1b",
      icon: <XCircle size={12} />,
      text: t.statusRejected,
    },
  };

  const config = statusConfig[status] || statusConfig.NOT_ASSIGNED;

  return (
    <span
      style={{ ...baseStyle, backgroundColor: config.bg, color: config.color }}
    >
      {config.icon}
      {config.text}
    </span>
  );
};

export default StatusBadge;